import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useIntl } from 'react-intl';
import type { RenderPropChildren } from 'types/children';

import { ReminderTileLayout } from '../components';

export const RefreshingTile: FC<PropsWithChildren<{ onAction: () => void; onClose: () => void }>> = ({
  onAction,
  onClose,
}) => {
  const { formatMessage } = useIntl();
  const onConfirm = useCallback(() => {
    onAction();
    onClose();
  }, [onAction, onClose]);

  return (
    <ReminderTileLayout
      icon="refresh"
      titleKey="dashboard.refreshing.title"
      messageKey="dashboard.refreshing.content"
      className="text-secondary"
    >
      <button className="btn btn-lg btn-discreet-secondary flex-grow-1 px-1 mx-1 flex-basis-100" onClick={onClose}>
        {formatMessage({ id: 'dashboard.cancel' })}
      </button>
      <button className="btn btn-lg btn-outline-secondary flex-grow-1 px-1  mx-1 flex-basis-100" onClick={onConfirm}>
        {formatMessage({ id: 'dashboard.refresh' })}
      </button>
    </ReminderTileLayout>
  );
};

RefreshingTile.displayName = 'RefreshingTile';

type WithRefreshingTileProps = Readonly<{ onRefresh: (() => void) | undefined }>;

export const WithRefreshingTile: FC<
  WithRefreshingTileProps & RenderPropChildren<{ onRefreshing: (() => void) | undefined }>
> = ({ children, onRefresh }) => {
  if (onRefresh === undefined) {
    return <>{children({ onRefreshing: undefined })}</>;
  }

  return (
    <WithToggle isInitiallyOn={false}>
      {({ isOn, toggleOff, toggleOn }) => {
        if (isOn) {
          return <RefreshingTile onAction={onRefresh} onClose={toggleOff} />;
        }
        return <>{children({ onRefreshing: toggleOn })}</>;
      }}
    </WithToggle>
  );
};
